import React from 'react';

import MaintenanceWindowsV2Container from '@totem/components/maintenanceWindowsV2/MaintenanceWindowsV2Container';
import MaintenanceWindowsV2Layout from '@totem/components/maintenanceWindowsV2/MaintenanceWindowsV2Layout';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

const MaintenanceWindowsV2Page = () => (
  <ContentLayout>
    <MaintenanceWindowsV2Container>
      <MaintenanceWindowsV2Layout />
    </MaintenanceWindowsV2Container>
  </ContentLayout>
);

export default MaintenanceWindowsV2Page;
